export const ERROR_MESSAGE_CUSTOMER_NOT_FOUND =
  'お客様情報が見つかりませんでした'
export const ERROR_MESSAGE_EMAIL_FORMAT = 'メールアドレスの形式でご入力ください'
export const ERROR_MESSAGE_EMAIL_ALREADY_REGISTERED =
  'すでに登録されているメールアドレスです'
export const ERROR_MESSAGE_EMAIL_DUPLICATED =
  '現在のメールアドレスと異なるメールアドレスを入力してください'
export const ERROR_MESSAGE_UNEXPECTED = '予期せぬエラーが発生しました'
export const ERROR_MESSAGE_INVALID_TOKEN = 'URLが無効です'
